import { PageHeader } from "@/components/common/PageParts";
import { JsonFileCard, PackageCard, PasteCard } from "@/components/import/ImportMethods";
import { DraftList } from "@/components/import/DraftList";
import { FormatGuide } from "@/components/import/FormatGuide";

export default function ImportHub() {
  return (
    <div className="container-x space-y-10 py-12" data-testid="import-hub-page">
      <PageHeader eyebrow="Card & set importer" title="Import cards and sets" testid="import-hub-header"
        description="Bring in cards made in ChatGPT or other tools without retyping them. You'll review every card and assign its finished card images before anything is saved." />
      <div className="grid gap-6 lg:grid-cols-3">
        <JsonFileCard />
        <PasteCard />
        <PackageCard />
      </div>
      <DraftList />
      <FormatGuide />
    </div>
  );
}
